<template>
  <div
    v-if="message.show"
    :class="[
      'fixed top-5 right-5 max-w-sm w-full p-4 rounded-lg shadow-lg flex items-start gap-4 border animate-slide-in z-[1000000]',
      message.type === 'success'
        ? 'bg-white border-green-300 text-green-800'
        : 'bg-white border-red-300 text-red-800',
    ]"
  >
    <div
      class="flex items-center justify-center w-12 h-12 rounded-full bg-gray-100"
    >
      <component
        :is="message.type === 'success' ? CheckCircle : AlertCircle"
        class="w-6 h-6 text-green-500"
      />
    </div>

    <div class="flex-1">
      <h4 class="font-semibold text-base">
        {{ message.type === "success" ? "Success!" : "Error!" }}
      </h4>
      <p class="text-sm text-gray-600 mt-1">
        {{ message.message }}
      </p>
    </div>

    <button
      @click="$emit('hide')"
      class="text-gray-400 hover:text-gray-600 transition transform hover:scale-110"
    >
      <X class="w-5 h-5" />
    </button>
  </div>
</template>

<script setup>
  import { CheckCircle, AlertCircle, X } from "lucide-vue-next";

  defineProps({
    message: {
      type: Object,
      default: () => ({
        show: false,
        type: "success",
        message: "",
      }),
    },
  });

  defineEmits(["hide"]);
</script>

<style scoped>
  @keyframes slide-in {
    0% {
      transform: translateY(-20%) scale(0.95);
      opacity: 0;
    }
    100% {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  .animate-slide-in {
    animation: slide-in 0.4s ease-out;
  }
</style>
